import RestrictedUserRoute from "discourse/routes/restricted-user";

export default class PreferencesTags extends RestrictedUserRoute {}
